import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _95d624fa = () => interopDefault(import('../pages/sets/_.vue' /* webpackChunkName: "pages/sets/_" */))
const _00f6bd6e = () => interopDefault(import('../pages/service/index_old.vue' /* webpackChunkName: "pages/service/index_old" */))
const _af1c53e8 = () => interopDefault(import('../pages/service-calculator/_.vue' /* webpackChunkName: "pages/service-calculator/_" */))
const _32fcbb06 = () => interopDefault(import('../pages/service/index.vue' /* webpackChunkName: "pages/service/index" */))
const _0a9a2ee6 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _a7ddc110 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _8a9bc5a0 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _872e8310 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _38dd408a = () => interopDefault(import('../pages/collection/_slug.vue' /* webpackChunkName: "pages/collection/_slug" */))
const _cd1c9f12 = () => interopDefault(import('../pages/catalog/_.vue' /* webpackChunkName: "pages/catalog/_" */))
const _2042e76a = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _03d49014 = () => interopDefault(import('../pages/cart/success/_hash.vue' /* webpackChunkName: "pages/cart/success/_hash" */))
const _c30dca66 = () => interopDefault(import('../pages/cart/share/_slug.vue' /* webpackChunkName: "pages/cart/share/_slug" */))
const _877d1af6 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _275cbfc4 = () => interopDefault(import('../pages/cars/index.vue' /* webpackChunkName: "pages/cars/index" */))
const _41ea2a69 = () => interopDefault(import('../pages/brands/_slug.vue' /* webpackChunkName: "pages/brands/_slug" */))
const _7a0b97ed = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/sets/*",
    component: _95d624fa,
    name: "sets-all"
  }, {
    path: "/service/index_old",
    component: _00f6bd6e,
    name: "service-index_old"
  }, {
    path: "/service-calculator/*",
    component: _af1c53e8,
    name: "service-calculator-all"
  }, {
    path: "/service-calculator",
    components: {
      default: _af1c53e8
    }
  }, {
    path: "/service",
    component: _32fcbb06,
    name: "service"
  }, {
    path: "/search",
    component: _0a9a2ee6,
    name: "search"
  }, {
    path: "/product/:slug?",
    component: _a7ddc110,
    name: "product-slug"
  }, {
    path: "/news/:slug",
    component: _8a9bc5a0,
    name: "news-slug"
  }, {
    path: "/news",
    component: _872e8310,
    name: "news"
  }, {
    path: "/collection/:slug?",
    component: _38dd408a,
    name: "collection-slug"
  }, {
    path: "/catalog/*",
    component: _cd1c9f12,
    name: "catalog-all"
  }, {
    path: "/catalog",
    component: _2042e76a,
    name: "catalog"
  }, {
    path: "/cart/success/:hash?",
    component: _03d49014,
    name: "cart-success-hash"
  }, {
    path: "/cart/share/:slug?",
    component: _c30dca66,
    name: "cart-share-slug"
  }, {
    path: "/cart",
    component: _877d1af6,
    name: "cart"
  }, {
    path: "/cars",
    component: _275cbfc4,
    name: "cars"
  }, {
    path: "/brands/:slug?",
    component: _41ea2a69,
    name: "brands-slug"
  }, {
    path: "/*",
    component: _7a0b97ed,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
